(() => {
  const scriptNode = document.currentScript;
  const root = scriptNode?.closest('.sc-stock-check') || document.querySelector('.sc-stock-check');
  if (!root) return;
  if (root.dataset.stockCheckReady === '1') return;
  root.dataset.stockCheckReady = '1';
  const data = window.SuperCaliStockData || JSON.parse(root.querySelector('#stockData')?.textContent || '{}');
  let series = 'twoTone';
  let selectedSize = '';
  let selectedModel = '';
  let voteTarget = null;
  let votePanelOpen = false;
  let bottomActionMode = 'disabled';
  let bottomActionUrl = '';
  let restockRank = [];
  const FORM_SOURCE = 'supercali-stock-check-v1';
  const REQUEST_WEBHOOK = 'https://script.google.com/macros/s/AKfycby2HlvP2Nzm4U39-KPD_luIdJsvrgSbycO1R7buHyH_gDwR3T6h_VQJMj8lKbnQxnKb5Q/exec';
  const IS_LOCAL_MOCK = (location.hostname === '127.0.0.1' || location.hostname === 'localhost') && new URLSearchParams(location.search).get('mockVote') === '1';
  const SENT_REQUESTS_KEY = IS_LOCAL_MOCK ? 'supercaliStockSentRequestsMock' : 'supercaliStockSentRequests';
  function readSentRequests() {
    try {
      return JSON.parse(localStorage.getItem(SENT_REQUESTS_KEY) || '{}');
    } catch (error) {
      return {};
    }
  }

  function saveSentRequests(value) {
    try {
      localStorage.setItem(SENT_REQUESTS_KEY, JSON.stringify(value));
      return true;
    } catch (error) {
      return false;
    }
  }

  const sentRequests = readSentRequests();
  const $ = (id) => root.querySelector(`#${id}`);
  const safe = (value) => String(value || '').replace(/[&<>"']/g, (ch) => ({
    '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'
  }[ch]));

  function attr(value) {
    return safe(value).replace(/`/g, '&#96;');
  }

  function guideForSeries(s) {
    if (s === 'twoTone') return root.dataset.ewGuide || 'assets/ew-size-guide.png';
    return root.dataset.wGuide || 'assets/w-size-guide.png';
  }

  function imageForProduct(product) {
    if (!product) return '';
    if (product.normalizedImage) return assetUrl(product.normalizedImage);
    if (location.protocol === 'file:' || location.hostname === '127.0.0.1' || location.hostname === 'localhost') {
      return product.remoteImage || assetUrl(product.localImage || product.image || '');
    }
    return product.remoteImage || assetUrl(product.localImage || product.image || '');
  }

  function cardImageForProduct(product) {
    if (!product) return '';
    if (product.cardImage) return assetUrl(product.cardImage);
    return imageForProduct(product);
  }

  function assetUrl(path) {
    if (!path) return '';
    return window.SuperCaliAssetUrls?.[path] || path;
  }

  function needsWordmarkOverlay(product) {
    return ['MB', 'NB'].includes(product?.model || '') && !product?.normalizedImage;
  }

  function selectedSizeInfo() {
    if (!selectedSize) return null;
    const product = currentProduct();
    const fromProduct = product?.variants?.[selectedSize];
    if (fromProduct) return fromProduct;
    return (data.sizesBySeries[series] || []).find(size => size.key === selectedSize) || null;
  }

  function sizeConvertText() {
    const info = selectedSizeInfo();
    if (series === 'twoTone') {
      if (selectedSize && info?.sourceUs && info.sourceUs !== selectedSize) return `US ${selectedSize} ≈ US ${info.sourceUs}`;
      if (selectedSize) return `US ${selectedSize}`;
      return 'US size · EW width';
    }
    if (series === 'wayne') return selectedSize ? `US ${selectedSize}` : 'US W width';
    if (series === 'earl') return selectedSize ? `US ${selectedSize}` : 'US W width';
    if (series === 'collab') return selectedSize ? `US ${selectedSize}` : 'US W width';
    if (selectedSize) return `US ${selectedSize}`;
    return 'US size';
  }

  function guideCaption() {
    if (series === 'collab') return '666 has special fit.';
    return '';
  }

  function fitText(product) {
    if (series === 'twoTone') return ['US · EW width', selectedSize ? sizeConvertText() : ''];
    if (series === 'wayne') return ['US · W width', selectedSize ? sizeConvertText() : ''];
    if (series === 'earl') return ['US · W width', selectedSize ? sizeConvertText() : ''];
    if (product?.model === '666-1') return ['666 fit', 'Special size'];
    if (product?.model === 'EB' || product?.model === 'EB1') return ['US · W width', 'EB / EB1 separate'];
    if (series === 'collab') return ['US · W width', sizeConvertText()];
    return ['', ''];
  }

  function fitBadgeText(product) {
    if (series === 'twoTone') return 'EW width';
    if (series === 'wayne') return 'W width';
    if (series === 'earl') return 'W width';
    if (product?.model === '666-1') return '666 fit';
    if (product?.model === 'EB' || product?.model === 'EB1') return 'W width';
    if (series === 'collab') return 'W width';
    return 'US size';
  }

  function products() {
    return data.productsBySeries[series] || [];
  }

  function variantFor(product, size) {
    return product?.variants?.[size];
  }

  function policyFor(product, size) {
    if (!product) return { kind: 'restock', label: 'Want it', copy: 'Tell us if you want it.' };
    const variant = size ? variantFor(product, size) : null;
    if (variant?.policy) return variant.policy;
    if (product.lifecycle === 'final') return { kind: 'final', label: 'Final', copy: product.policyCopy || 'Discontinued.' };
    if (product.lifecycle === 'materialPaused') return { kind: 'material', label: 'Material', copy: product.policyCopy || 'Tell us if you want it.' };
    if (size && product.regularTargets && Object.keys(product.regularTargets).length && !product.regularTargets[size]) {
      return { kind: 'preorder', label: 'Want it', copy: 'Tell us if you want it.' };
    }
    return { kind: 'restock', label: product.policyLabel || 'Want it', copy: product.policyCopy || 'Tell us if you want it.' };
  }

  function isVoteLocked(product, policy) {
    return product?.model === 'EB1' && policy?.kind === 'final';
  }

  function sizeDisplay(size) {
    return size ? `US ${size}` : '';
  }

  function findProductByModel(model) {
    for (const list of Object.values(data.productsBySeries || {})) {
      const product = (list || []).find(p => p.model === model);
      if (product) return product;
    }
    return null;
  }

  function productFullLabel(product) {
    if (!product) return '';
    const model = product.displayModel || product.model || '';
    const name = product.displayName || product.title || '';
    return name ? `${model} · ${name}` : model;
  }

  function productSizeLabel(product, size) {
    return [productFullLabel(product), sizeDisplay(size)].filter(Boolean).join(' / ');
  }

  function voteKey(product, size) {
    return `${series}|${product?.model || selectedModel || ''}|${size || selectedSize || ''}`;
  }

  function requestNote(key) {
    if (sentRequests[key]) return '';
    return 'Click here to let the boss know.';
  }

  async function sendRestockRequest(payload) {
    if (IS_LOCAL_MOCK) {
      return { ok: true, mock: true };
    }
    if (!REQUEST_WEBHOOK) return { ok: false, demo: true };
    try {
      const res = await fetch(REQUEST_WEBHOOK, {
        method: 'POST',
        mode: 'no-cors',
        headers: { 'Content-Type': 'text/plain;charset=utf-8' },
        body: JSON.stringify(payload),
      });
      return { ok: true, demo: false };
    } catch (error) {
      return { ok: false, demo: false };
    }
  }

  function bumpRank(model, size, weight, hasContact, displayName = '') {
    const existing = restockRank.find(item => item.model === model && item.size === size);
    if (existing) {
      existing.score = Number(existing.score || 0) + weight;
      if (hasContact) existing.contactCount = Number(existing.contactCount || 0) + 1;
      if (displayName && !existing.displayName) existing.displayName = displayName;
    } else {
      restockRank.push({ model, size, displayName, score: weight, contactCount: hasContact ? 1 : 0 });
    }
    restockRank.sort((a, b) => Number(b.score || 0) - Number(a.score || 0));
    renderRank();
  }

  function renderRank() {
    const list = restockRank.slice(0, 10);
    $('rankBox').hidden = !list.length;
    if (!list.length) {
      $('rankList').innerHTML = '<div class="rank-empty">Tap if you want it.</div>';
      return;
    }
    $('rankList').innerHTML = list.map((item, index) => {
      const product = findProductByModel(item.model);
      const label = productSizeLabel(product || { model: item.model, displayName: item.displayName || '' }, item.size);
      const heat = item.contactCount ? 'contact' : 'wanted';
      return `<div class="rank-item">
        <b>#${index + 1}</b>
        <strong>${safe(label)}</strong>
        <span>${safe(heat)}</span>
      </div>`;
    }).join('');
  }

  function loadRank() {
    if (IS_LOCAL_MOCK) {
      restockRank = [
        { model: '7181', size: '1.5EW', score: 9, contactCount: 2 },
        { model: 'PP8', size: '8EW', score: 6, contactCount: 1 },
        { model: '7118', size: '5EW', score: 4, contactCount: 0 },
      ];
      renderRank();
      return;
    }
    const callbackName = `supercaliRank${Date.now()}${Math.random().toString(16).slice(2)}`;
    window[callbackName] = (payload) => {
      restockRank = Array.isArray(payload?.rank) ? payload.rank : [];
      renderRank();
      delete window[callbackName];
      script.remove();
    };
    const script = document.createElement('script');
    script.src = `${REQUEST_WEBHOOK}?action=rank&callback=${encodeURIComponent(callbackName)}`;
    script.onerror = () => {
      renderRank();
      delete window[callbackName];
      script.remove();
    };
    document.head.appendChild(script);
  }

  function isAvailable(product, size) {
    return Boolean(variantFor(product, size)?.available);
  }

  function anyAvailable(product) {
    return Object.values(product.variants || {}).some(v => v.available);
  }

  function anyLow(product) {
    return Object.values(product.variants || {}).some(v => v.lowStock);
  }

  function availabilityForSize(size) {
    if (series === 'collab' && !selectedModel) return { available: false, low: false };
    const relevant = selectedModel ? products().filter(p => p.model === selectedModel) : products();
    const variants = relevant.map(p => variantFor(p, size)).filter(Boolean);
    return {
      available: variants.some(v => v.available),
      low: Boolean(selectedModel) && variants.some(v => v.lowStock),
    };
  }

  function availabilityForProduct(product) {
    if (selectedSize) {
      const v = variantFor(product, selectedSize);
      return { available: Boolean(v?.available), low: Boolean(v?.lowStock), variant: v, policy: policyFor(product, selectedSize) };
    }
    const variants = Object.values(product.variants || {});
    return {
      available: variants.some(v => v.available),
      low: false,
      variant: null,
      policy: policyFor(product, ''),
    };
  }

  function sizeCountForProduct(product) {
    return Object.values(product.variants || {}).filter(v => v.available).length;
  }

  function sizeCountLabel(product) {
    const count = sizeCountForProduct(product);
    return `${count} ${count === 1 ? 'size' : 'sizes'}`;
  }

  function currentProduct() {
    return products().find(p => p.model === selectedModel) || null;
  }

  function currentVariant() {
    const product = currentProduct();
    return selectedSize && product ? variantFor(product, selectedSize) : null;
  }

  function scrollBelowSticky(element) {
    if (!element) return;
    const topOffset = root.querySelector('.top')?.offsetHeight || 0;
    const target = element.getBoundingClientRect().top + window.scrollY - topOffset - 8;
    window.scrollTo({ top: Math.max(0, target), behavior: 'smooth' });
  }

  function setSeries(next) {
    series = next;
    selectedSize = '';
    selectedModel = '';
    voteTarget = null;
    votePanelOpen = false;
    $('guide').classList.remove('open');
    render();
  }

  function setSize(size) {
    selectedSize = selectedSize === size ? '' : size;
    voteTarget = null;
    votePanelOpen = false;
    render();
    if (selectedSize && !selectedModel) {
      requestAnimationFrame(() => scrollBelowSticky($('colors').closest('.section') || $('colors')));
    }
  }

  function setProduct(model) {
    const becameSelected = selectedModel !== model;
    selectedModel = becameSelected ? model : '';
    voteTarget = null;
    votePanelOpen = false;
    render();
  }

  function resetVoteUi() {
    $('notifyFields').hidden = true;
    $('contactButton').textContent = 'Send contact';
    $('contactButton').disabled = false;
    $('voteHeat').textContent = '';
  }

  function setVote(product) {
    selectedModel = product.model;
    if (!selectedSize) {
      voteTarget = null;
      votePanelOpen = false;
      render();
      requestAnimationFrame(() => scrollBelowSticky($('sizes').closest('.section') || $('sizes')));
      return;
    }
    voteTarget = { model: product.model, size: selectedSize || '' };
    votePanelOpen = false;
    render();
  }

  function clearSelection() {
    selectedSize = '';
    selectedModel = '';
    voteTarget = null;
    votePanelOpen = false;
    $('voteBox').hidden = true;
    $('guide').classList.remove('open');
    resetVoteUi();
    render();
    requestAnimationFrame(() => window.scrollTo({ top: 0, behavior: 'smooth' }));
  }

  function renderTabs() {
    $('tabs').innerHTML = data.seriesOrder.map(s => `
      <button type="button" class="tab ${s === series ? 'active' : ''}" data-action="series" data-series="${attr(s)}">${data.seriesLabels[s]}</button>
    `).join('');
  }

  function renderStockNote() {
    const date = data.stockDate || 'latest update';
    $('stockNote').innerHTML = `<strong>Last update: ${safe(date)}</strong><span>Almost gone may sell out. Final = discontinued.</span>`;
  }

  function renderSizes() {
    if (series === 'collab' && !selectedModel) {
      $('sizes').innerHTML = '<button type="button" class="size empty" disabled><strong>Pick style</strong><small>then size</small></button>';
      return;
    }
    const sizeSource = selectedModel
      ? Object.values(currentProduct()?.variants || {}).map(v => ({ key: v.key, label: v.label, eur: v.eur, sex: v.sex, source: v.source, sourceUs: v.sourceUs }))
        : (data.sizesBySeries[series] || []);
    const sizeSort = (key) => {
      const match = String(key || '').match(/[0-9]+(?:[.][0-9]+)?/);
      return match ? Number(match[0]) : 999;
    };
    const uniqueSizes = [...new Map(sizeSource.map(s => [s.key, s])).values()].sort((a,b) => sizeSort(a.key) - sizeSort(b.key) || String(a.key).localeCompare(String(b.key)));
    $('sizes').innerHTML = uniqueSizes.map(size => {
      const state = availabilityForSize(size.key);
      const active = size.key === selectedSize;
      const sex = size.sex ? ` · ${size.sex}` : '';
      const eur = size.eur ? `EUR ${size.eur}${sex}` : sex.replace(' · ', '');
      const mainLabel = size.label ? `US ${size.label}` : 'US';
      return `<button type="button" class="size ${active ? 'active' : ''} ${state.available ? 'available' : 'empty'} ${state.low ? 'low' : ''}" data-action="size" data-size="${attr(size.key)}" title="${safe(size.source)}">
        <strong>${safe(mainLabel)}</strong>
        <small>${safe(eur)}</small>
        ${state.low ? '<span class="low-note">Almost gone</span>' : ''}
      </button>`;
    }).join('');
  }

  function renderColors() {
    const list = products();
    $('colorHint').textContent = '';
    $('colors').classList.toggle('collab-colors', series === 'collab');
    $('colors').innerHTML = list.map(p => {
      const state = availabilityForProduct(p);
      const active = p.model === selectedModel;
      const policy = state.policy || policyFor(p, selectedSize);
      const tag = state.available
        ? (state.low ? 'Low' : (policy.kind === 'final' ? 'Final' : ''))
        : (policy.kind === 'final' ? 'Final' : '');
      const tagClass = state.low ? 'tag low' : (policy.kind === 'final' ? 'tag final' : 'tag');
      const sub = `<span>${safe(p.displayName || '')}</span>`;
      const action = state.available ? 'product' : 'vote';
      return `<button type="button" class="color ${state.available ? 'available' : 'sold'} ${active ? 'active' : ''}" data-action="${action}" data-model="${attr(p.model)}" aria-label="${safe(p.displayModel || p.model)} ${state.available ? 'in stock' : 'sold out'}">
        <img src="${safe(cardImageForProduct(p))}" alt="${safe(p.model)}">
        <div><div class="name">${safe(p.displayModel || p.model)}</div><div class="sub">${sub}</div></div>
        ${tag ? `<span class="${tagClass}">${safe(tag)}</span>` : ''}
      </button>`;
    }).join('');
  }

  function renderHero() {
    const product = currentProduct();
    const variant = currentVariant();
    const fallback = products().find(anyAvailable) || products()[0] || {};
    const displayProduct = product || fallback;
    $('heroImage').src = imageForProduct(displayProduct) || '';
    $('heroImage').alt = displayProduct.model || '';
    $('heroWordmark').src = assetUrl('assets/supercali-wordmark.png');
    $('heroWordmark').classList.toggle('open', needsWordmarkOverlay(displayProduct));
    const fit = fitText(product);
    $('fitNote').innerHTML = `${safe(fit[0])}<span>${safe(fit[1])}</span>`;
    $('fitBadge').textContent = fitBadgeText(product);
    if (product?.materialNote?.label) {
      $('materialNote').classList.add('open');
      $('materialNote').innerHTML = `${safe(product.materialNote.label)}<span>${safe(product.materialNote.copy || '')}</span>`;
    } else {
      $('materialNote').classList.remove('open');
      $('materialNote').innerHTML = '';
    }

    if (product && selectedSize) {
      const policy = policyFor(product, selectedSize);
      $('selectedModel').textContent = productFullLabel(product);
      $('selectedTitle').textContent = sizeDisplay(selectedSize);
      if (variant?.available) {
        bottomActionMode = 'product';
        bottomActionUrl = product.url || '#';
        $('bottomAction').classList.remove('disabled');
        $('bottomAction').disabled = false;
        $('bottomAction').textContent = 'Product page';
        $('bottomTitle').textContent = productSizeLabel(product, selectedSize);
        $('bottomSub').textContent = '';
      } else {
        const voteLocked = isVoteLocked(product, policy);
        bottomActionMode = voteLocked ? 'disabled' : 'vote';
        bottomActionUrl = '';
        $('bottomAction').classList.toggle('disabled', voteLocked);
        $('bottomAction').disabled = voteLocked;
        $('bottomAction').textContent = voteLocked ? 'Final' : 'I really want this!!!';
        $('bottomTitle').textContent = productSizeLabel(product, selectedSize);
        $('bottomSub').textContent = voteLocked ? '' : 'Click here to let the boss know ->';
      }
      return;
    }

    if (product) {
      $('selectedModel').textContent = productFullLabel(product);
      $('selectedTitle').textContent = `Pick size · ${sizeCountLabel(product)}`;
      bottomActionMode = 'disabled';
      bottomActionUrl = '';
      $('bottomAction').classList.add('disabled');
      $('bottomAction').disabled = true;
      $('bottomAction').textContent = 'Pick size';
      $('bottomTitle').textContent = productFullLabel(product);
      $('bottomSub').textContent = 'Pick a size';
      return;
    }

    if (selectedSize) {
      $('selectedModel').textContent = sizeDisplay(selectedSize);
      $('selectedTitle').textContent = 'Pick color';
      $('bottomTitle').textContent = sizeDisplay(selectedSize);
      $('bottomSub').textContent = 'Pick a color';
      bottomActionMode = 'disabled';
      bottomActionUrl = '';
      $('bottomAction').classList.add('disabled');
      $('bottomAction').disabled = true;
      $('bottomAction').textContent = 'Pick color';
    } else {
      $('selectedModel').textContent = 'Pick color or size';
      $('selectedTitle').textContent = 'No checkout here';
      $('bottomTitle').textContent = 'Choose color + size';
      $('bottomSub').textContent = '';
      bottomActionMode = 'disabled';
      bottomActionUrl = '';
      $('bottomAction').classList.add('disabled');
      $('bottomAction').disabled = true;
      $('bottomAction').textContent = 'Choose first';
    }
  }

  function renderVote() {
    const product = currentProduct();
    if (!votePanelOpen || !voteTarget) {
      $('voteBox').hidden = true;
      return;
    }
    $('voteBox').hidden = false;
    const target = voteTarget || { model: product.model, size: selectedSize };
    const targetProduct = products().find(p => p.model === target.model) || product;
    const policy = policyFor(targetProduct, target.size);
    const key = voteKey(targetProduct, target.size);
    const needsSize = !target.size;
    const voteLocked = isVoteLocked(targetProduct, policy);
    const alreadySent = Boolean(sentRequests[key]);
    $('voteBox').querySelector('h3').textContent = needsSize ? 'Pick size' : (voteLocked ? 'Final' : 'Want this size?');
    const sizeLabel = target.size || 'choose size';
    $('voteCopy').textContent = needsSize
      ? `${productFullLabel(targetProduct || { model: target.model })} · pick size`
      : productSizeLabel(targetProduct || { model: target.model }, sizeLabel);
    if (needsSize || voteLocked) $('notifyFields').hidden = true;
    if (alreadySent) $('notifyFields').hidden = false;
    $('contactButton').textContent = 'Send contact';
    $('contactButton').disabled = false;
    $('voteHeat').textContent = voteLocked ? 'Final.' : requestNote(key);
  }

  async function submitVote({ includeContact = false } = {}) {
    const target = voteTarget || { model: selectedModel || 'style', size: selectedSize || 'size' };
    const targetProduct = products().find(p => p.model === target.model) || currentProduct();
    if (!targetProduct || !target.size) return false;
    const policy = policyFor(targetProduct, target.size);
    if (isVoteLocked(targetProduct, policy)) return false;
    const key = voteKey(targetProduct, target.size);
    const alreadySent = Boolean(sentRequests[key]);
    if (alreadySent && !includeContact) {
      votePanelOpen = true;
      $('voteBox').hidden = false;
      $('notifyFields').hidden = false;
      $('voteHeat').textContent = '';
      if (bottomActionMode === 'vote') {
        $('bottomAction').textContent = 'Boss got it!';
        $('bottomAction').disabled = true;
        $('bottomAction').classList.add('disabled');
        $('bottomSub').textContent = '';
      }
      scrollBelowSticky($('wantSection'));
      return true;
    }
    if (includeContact) {
      $('contactButton').textContent = 'Sending...';
      $('contactButton').disabled = true;
    }
    if (bottomActionMode === 'vote') {
      $('bottomAction').textContent = 'Saving...';
      $('bottomAction').disabled = true;
    }
    const clientSentAt = new Date().toISOString();
    const result = await sendRestockRequest({
      series,
      model: target.model,
      size: target.size || '',
      displayName: targetProduct?.displayName || '',
      policy,
      stockDate: data.stockDate || '',
      instagram: includeContact ? ($('igInput')?.value || '') : '',
      phone: includeContact ? ($('phoneInput')?.value || '') : '',
      requestType: includeContact ? 'notify_contact' : 'anonymous_vote',
      priorityWeight: includeContact ? 3 : 1,
      contactProvided: includeContact ? 'yes' : 'no',
      website: $('websiteInput')?.value || '',
      source: FORM_SOURCE,
      clientRequestId: `${Date.now()}-${Math.random().toString(16).slice(2)}`,
      clientSentAt,
      page: location.href,
      userAgent: navigator.userAgent,
    });
    if (result.ok) {
      sentRequests[key] = clientSentAt;
      saveSentRequests(sentRequests);
      bumpRank(target.model, target.size, includeContact ? 3 : 1, includeContact, targetProduct?.displayName || '');
      votePanelOpen = true;
      $('voteBox').hidden = false;
      $('voteBox').querySelector('h3').textContent = 'Want this size?';
      $('voteCopy').textContent = productSizeLabel(targetProduct, target.size);
      $('notifyFields').hidden = false;
      $('contactButton').textContent = includeContact ? 'Sent' : 'Send contact';
      $('contactButton').disabled = Boolean(includeContact);
      $('voteHeat').textContent = includeContact
        ? 'Contact saved. Please keep DM open.'
        : '';
      if (bottomActionMode === 'vote') {
        $('bottomAction').textContent = 'Boss got it!';
        $('bottomAction').disabled = true;
        $('bottomAction').classList.add('disabled');
        $('bottomSub').textContent = '';
      }
      scrollBelowSticky($('wantSection'));
      return true;
    }
    if (includeContact) {
      $('contactButton').textContent = 'Try again';
      $('contactButton').disabled = false;
    }
    $('voteHeat').textContent = 'Try again.';
    if (bottomActionMode === 'vote') {
      $('bottomAction').textContent = 'I really want this!!!';
      $('bottomAction').disabled = false;
    }
    return false;
  }

  function render() {
    renderTabs();
    renderStockNote();
    renderSizes();
    $('guideImage').src = assetUrl(guideForSeries(series));
    $('guideCaption').textContent = guideCaption();
    renderHero();
    renderColors();
    renderVote();
  }

  root.addEventListener('click', (event) => {
    const button = event.target.closest('[data-action]');
    if (!button || !root.contains(button)) return;
    const action = button.dataset.action;
    if (action === 'series') setSeries(button.dataset.series || 'twoTone');
    if (action === 'size') setSize(button.dataset.size || '');
    if (action === 'product') setProduct(button.dataset.model || '');
    if (action === 'vote') {
      const product = products().find(p => p.model === button.dataset.model);
      if (product) setVote(product);
    }
  });
  $('guideToggle').addEventListener('click', () => $('guide').classList.toggle('open'));
  $('clearSelectionTop').addEventListener('click', clearSelection);
  $('contactButton').addEventListener('click', async () => {
    if (!($('igInput')?.value || $('phoneInput')?.value)) {
      $('voteHeat').textContent = 'Add Instagram or phone first.';
      return;
    }
    await submitVote({ includeContact: true });
  });
  $('bottomAction').addEventListener('click', async () => {
    if (bottomActionMode === 'product' && bottomActionUrl) {
      window.location.href = bottomActionUrl;
      return;
    }
    if (bottomActionMode === 'vote') {
      const product = currentProduct();
      if (product && selectedSize) {
        voteTarget = { model: product.model, size: selectedSize };
        votePanelOpen = true;
        renderVote();
        await submitVote({ includeContact: false });
      }
    }
  });
  render();
  loadRank();
  })();
